/** ADR-0007 operators owned by tasks-service / template-nestjs `_core`. */
export type TaskFilterOperator =
  | 'eq'
  | 'in'
  | 'ge'
  | 'le'
  | 'gt'
  | 'lt'
  | 'contains'
  | 'like'
  | 'between'

export type ExplicitTaskFilter = { operator: TaskFilterOperator; value: unknown }

export function toTaskFilter(operator: TaskFilterOperator, value: unknown): ExplicitTaskFilter {
  return { operator, value }
}
